import { inject, Injectable } from '@angular/core';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { ContextMenuOptionsService } from './context-menu-options.service';
import { ContextMenuService } from './context-menu.service';

@Injectable()
export class ShapeListContextMenuService {
  private contextMenuOptionsService = inject(ContextMenuOptionsService);
  private contextMenuService = inject(ContextMenuService);

  async open(clientPoint: Point2D, targetedShapeIndex: number) {
    const menuOptions =
      this.contextMenuOptionsService.getShapeListContextMenuOptions(
        targetedShapeIndex,
      );
    this.contextMenuService.open(menuOptions, clientPoint, true);
  }
}
